import { render, staticRenderFns } from "./InvitesFooter.vue?vue&type=template&id=15d5ef50"
import script from "./InvitesFooter.vue?vue&type=script&lang=js"
export * from "./InvitesFooter.vue?vue&type=script&lang=js"
import style0 from "./InvitesFooter.vue?vue&type=style&index=0&id=15d5ef50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports